import React, { Component } from "react";
import { PageHeader, Button, Alert, Spin } from "antd";
import OpsReportService from "../../services/opsreportservice";

/**
 * Audit -> Orders Heatmap. Order density over the areas we cover, refreshed weekly.
 *
 * Unlike the Ads Report this one cannot be sandboxed into a srcDoc frame: it draws with the Google
 * Maps JS API, which refuses to run under about:srcdoc or a blob: URL and renders a blank map. So
 * the page is served at its own URL by the WebAPI, and the frame is authorised by the short-lived
 * HttpOnly cookie that OpsReportTicket sets after checking the "Ops Review" right. The map itself
 * is self-contained - its data is inlined when the page is composed on the server, so nothing is
 * fetched from a relative path that would no longer resolve.
 */
export default class OrdersHeatmap extends Component {
  constructor(props) {
    super(props);
    this.service = new OpsReportService();
    this.state = { url: "", loading: true, error: "" };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ loading: true, error: "", url: "" });
    this.service
      .getViewUrl("heatmap")
      .then((out) => {
        if (out && out.url) {
          this.setState({ url: out.url, loading: false });
        } else {
          this.setState({
            loading: false,
            error:
              (out && out.message) ||
              "Could not load the heatmap. Try again in a moment.",
          });
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: "Could not load the heatmap. Try again in a moment.",
        });
      });
  };

  render() {
    const { url, loading, error } = this.state;
    return (
      <div className="orders-heatmap-wrap">
        <PageHeader
          title="Orders Heatmap"
          subTitle="Order density across the areas we cover - refreshed weekly"
          extra={[
            <Button key="refresh" onClick={this.load} disabled={loading}>
              Refresh
            </Button>,
          ]}
        />
        {error ? (
          <Alert type="warning" showIcon message={error} style={{ margin: 16 }} />
        ) : null}
        {loading ? (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spin tip="Loading the map..." />
          </div>
        ) : null}
        {!loading && !error && url ? (
          <iframe
            title="Orders Heatmap"
            src={url}
            style={{
              width: "100%",
              height: "calc(100vh - 170px)",
              border: "1px solid #e8e8e8",
              borderRadius: 4,
              background: "#fff",
            }}
          />
        ) : null}
      </div>
    );
  }
}
